class MeasurementsCountChart {

    constructor(el, data = []) {
        this.container = document.getElementById(el);
        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        // this.canvas.height = this.maxY * 6.5;
        this.canvas.style = "margin-left: 15px; margin-right: 45px;";

        var ctx = this.canvas.getContext("2d");

        var backgroundGradient = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient.addColorStop(0.7, 'rgba(0, 132, 227, 0)');
        backgroundGradient.addColorStop(0, 'rgba(0, 132, 227, 0.2)');
        // backgroundGradient.addColorStop(0, 'rgba(0, 132, 227, 0.25)');
        // backgroundGradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');

        this.container.appendChild(this.canvas);

        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                labels: [],
                datasets: [{
                    borderColor: '#0084e3',
                    borderWidth: 3,
                    radius: 8,
                    pointBackgroundColor: 'white',
                    data: [],
                    fill: true,
                    backgroundColor: backgroundGradient,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                }]
            },
            options: {
                layout: {
                    // padding: {
                    //     left: -10,
                    //     bottom: -10
                    // }
                },
                // animation: false,
                interaction: {
                    intersect: false
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItem) {
                                return '';
                            },
                        }
                    },
                },
                scales: {
                    x: {
                        // type: 'linear',
                        // min: 0,
                        // max: 31,
                        grid: {
                            borderWidth: 0,
                            color: function(line) {
                                return false;
                            }
                        },
                        ticks: {
                            display: true,
                            // stepSize: 1,
                            color: '#ccc',
                            font: {
                                size: 16,
                            },
                            callback: function(val, index) {
                                // Hide the label of every 2nd dataset
                                return index % 2 === 0 ? this.getLabelForValue(val) : '';
                            },
                        },
                    },
                    y: {
                        min: 0,
                        max: 50,
                        type: 'linear',
                        grid: {
                            borderWidth: 0,
                            borderDash: [5],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: '#ccc',
                            font: {
                                size: 16,
                            },
                            callback: function(value, index) {
                                return value + '   ';
                            }
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: true
            }
        });
    }

    getData(from, to) {
        var debug = getUrlParameter('debug', false);

        $.ajax({
            // url: '{{ route("dashboard.measurements.count", [ "from" => $fromDate->format("Y-m-d"), "to" => $toDate->format("Y-m-d") ]) }}',
            url: '/dashboard/measurements-count/'+from+'/'+to,
            method: 'GET',
            success: (data) => {
                var from_date = moment(from, 'YYYY-MM-DD');
                var to_date = moment(to, 'YYYY-MM-DD');
                if(debug) {
                    console.debug('date', from_date, to_date);
                }

                this.chart.data.labels = [];
                for(var date = moment(from_date); date <= to_date; date.add(1, 'days')) {
                    // console.debug('addind label...');
                    this.chart.data.labels.push(date.format('MMM D'));
                }

                var max = 50;
                for(var i=0; i<data.length; i++) {
                    if(debug) {
                        data[i] = data[i] + parseInt((Math.random()*50)+5);
                    }

                    var newMax = Math.ceil((data[i]+1)/10)*10;
                    if(max < newMax) {
                        max = newMax;
                    }
                }

                this.chart.data.datasets[0].data = data;
                this.chart.options.scales.y.max = max;

                if(debug) {
                    console.debug(this.chart.data.labels, this.chart.data.datasets[0].data, this.chart.options.scales.y.max);
                }

                this.chart.update();
            }
        });
    }
}

window.MeasurementsCountChart = MeasurementsCountChart;